export type EventEmailPresentation = {
  bodyText: string;
  subject: string;
  locale: string;
  organizationName: string;
  organizationLogoUrl: string | null;
  organizationAccent: string | null;
  eventType?: string | null;
  communicationType?: string;
};

/** Shared by the admin preview and SES; all editable content stays plain text. */
export function renderEventEmailHtml(input: EventEmailPresentation): string {
  const ar = input.locale === "ar";
  const dir = ar ? "rtl" : "ltr";
  const accent = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/iu.test(input.organizationAccent ?? "")
    ? input.organizationAccent!
    : "#00796b";
  const label =
    input.eventType === "janazah"
      ? ar
        ? "إشعار جنازة"
        : "Janazah notice"
      : input.eventType === "friday_program"
        ? ar
          ? "برنامج الجمعة"
          : "Community Friday"
        : input.communicationType === "urgentNotice"
          ? ar
            ? "إشعار عاجل"
            : "Urgent notice"
          : ar
            ? "فعالية مجتمعية"
            : "Community event";
  const logo = safeImageUrl(input.organizationLogoUrl);
  const body = input.bodyText
    .trim()
    .split(/\n{2,}/u)
    .filter(Boolean)
    .map(
      (block) =>
        `<p dir="auto" style="margin:0 0 20px;white-space:pre-wrap;overflow-wrap:anywhere">${escapeHtml(block)}</p>`,
    )
    .join("");
  const footer = ar
    ? `أُرسلت بواسطة ${input.organizationName} عبر شديد.`
    : `Sent by ${input.organizationName} via Shdeed.`;
  return `<!doctype html>
<html lang="${ar ? "ar" : "en"}" dir="${dir}">
<head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"></head>
<body style="margin:0;background:#f3f5f6;color:#202a30;font-family:Arial,sans-serif;letter-spacing:0">
<table role="presentation" style="width:100%;border-collapse:collapse"><tr><td style="padding:16px 8px">
<table role="presentation" style="width:100%;max-width:620px;margin:auto;background:#fff;border:1px solid #d9e0e3;border-top:4px solid ${accent};border-collapse:collapse">
<tr><td style="padding:24px 24px 16px;border-bottom:1px solid #e4e8ea">
${logo ? `<img src="${escapeHtml(logo)}" alt="" style="display:block;max-height:56px;max-width:160px;margin-bottom:16px">` : ""}
<p style="margin:0 0 8px;color:${accent};font-size:13px;font-weight:bold">${escapeHtml(input.organizationName)} · ${label}</p>
<h1 dir="auto" style="margin:0;font-size:24px;line-height:1.4;overflow-wrap:anywhere">${escapeHtml(input.subject)}</h1>
</td></tr><tr><td style="padding:24px;font-size:16px;line-height:1.75">${body}</td></tr>
<tr><td style="padding:16px 24px;border-top:1px solid #e4e8ea;color:#59656b;font-size:12px;line-height:1.6">${escapeHtml(footer)}</td></tr>
</table></td></tr></table></body></html>`;
}

function safeImageUrl(value: string | null): string | null {
  if (!value) return null;
  try {
    return new URL(value).protocol === "https:" ? value : null;
  } catch {
    return null;
  }
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
